// The one asset service instance the shim routes (/api/assets*, /api/transcribe*,
// /api/transcripts/*, /api/analyze) and the render runner share. Logic lives in
// assets.js; this file only wires the browser dependencies.
import { createAssetService } from './assets.js';
import { putBlob, getBlob } from './mediaStore.js';
import { transcribeViaGroqProxy } from '../lib/engine/transcribeApi.js';
import { transcribeVideo } from '../lib/engine/transcribe.js';

// Same transcriber Qlipper Lite uses (audio extracted on-device, sent to the /yt/groq
// bridge — free engine or the user's Groq key). If that's unavailable (free engine off,
// bridge down), fall back to in-browser Whisper, which is slow but needs no server.
export async function transcribeUpload(blob, { language = 'id', onProgress } = {}) {
  try {
    return await transcribeViaGroqProxy(blob, { language, onProgress });
  } catch (e) {
    console.warn('[shim] Groq transcription failed, falling back to in-browser Whisper:', e?.message || e);
    return transcribeVideo(blob, { language, onProgress: (p) => onProgress?.(typeof p?.progress === 'number' ? p.progress / 100 : 0) });
  }
}

export const assetService = createAssetService({ putBlob, getBlob, transcribe: transcribeUpload });
